import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210630/1.jpg';
import image2 from '@/assets/images/news/detail/20210630/2.png';
import image3 from '@/assets/images/news/detail/20210630/3.jpg';
import image4 from '@/assets/images/news/detail/20210630/4.jpg';

export default {
  id: '20210630', //  模块 id
  title:
    '不忘初心，永跟党走——叮咚买菜庆祝建党100周年暨“一周一课”颁奖活动顺利举行', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '为学习贯彻习近平总书记在党史学习教育动员大会上的重要讲话精神，庆祝中国共产党成立100周年，根据全党“学党史、强信念、跟党走”学习教育活动要求，积极响应党的号召，叮咚买菜从5月开始在叮咚学堂推出“一周一课”学习习近平系列讲话活动。学习过此课程的同学都知道，这是一门线上党课，每节课分为两部分，第一部分为学习视频，第二部分为测试。按照原本的想法，大家工作都比较忙，可能关注这个事情的人比较少，但令我们惊喜的是，有近500名同学在学习这一系列课程，并完成考试，第一课有超100名同学获得满分。',
    },
    {
      type: NewsContentType.Text,
      text:
        '在6月29日，我们特举行了 “一周一课”优秀学员颁奖活动，对测试成绩累计得分最高的前三名同学进行表彰，他们分别是城市分选中心仓储运营支持部陈志云、行政部季羽婷和大客户销售部葛洪全，由叮咚买菜团委书记陈茁为他们颁发奖品。后续我们还将不定时举办此类颁奖活动，小伙伴们积极参加到“一周一课”当时学习活动当中，下次上台领奖的优秀同学就有可能是你。',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.Image,
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '活动当天，浦东双拥办的红色故事“三讲六进”也来到了叮咚买菜，主办方邀请了四位上海夏友梅故事艺术进修学校的优秀讲师来为叮咚的小伙伴们讲述老一辈党员的故事。有浦东的革命者周大根除地主、抗日的革命故事；也有川沙老党员为牺牲在抗美援朝战场上的战友照顾老母亲一辈子的生死诺言故事；还有前后写了五份入党申请书，历经千难万阻也要积极向党组织靠拢，加入党组织的党员故事。讲师们生动的讲解，感染了在场的小伙伴们，让我们身临其境般的领会到了革命先辈的奉献精神，他们的革命精神鼓舞着现在的我们顽强拼搏、全力以赴。',
    },
    {
      type: NewsContentType.Image,
      src: [image3],
    },
    {
      type: NewsContentType.Image,
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text:
        '明天，我们党就迎来了百年华诞，一辈又一辈革命先烈的奠基，让我们能够沐浴在党的光辉下，生活在现在这个美好的时代。叮咚买菜党总支将继续做好10000件小事，持续担负好一个民生互联网企业的责任，为用户带来更美好更新鲜的生鲜食材。不忘初心跟党走，祝我们伟大的党生日快乐！',
    },
  ],
};
